// extracted by mini-css-extract-plugin
export default {"logoBox":"index_logoBox_ATCSW","logo":"index_logo_WlEfZ","logoMil":"index_logoMil_baDG0","slogem":"index_slogem_i1elV","ad":"index_ad_1hu58"};